(function() {
  $(function() {
    return $.widget('custom.listitems', {
      options: {
        createMessageWriter: true,
        message_writer: null,
        createMultiDelete: true,
        listUrl: null,
        listOptions: {},
        listCallback: function() {
          return void 0;
        },
        template: null
      },
      _create: function() {
        if (this.options.createMessageWriter) {
          if (!this.options.message_writer) {
            this.options.message_writer = +new Date();
          }
          return this._createMessageWriter();
        }
      },
      _setOption: function() {
        return void 0;
      },
      destroy: function() {
        return void 0;
      },
      list: function() {
        var msgWriter, opts;
        opts = this.options;
        msgWriter = $(opts.message_writer);
        if (opts.message_writer != null) {
          msgWriter.message_writer();
          msgWriter.message_writer('info', 'Loading...');
        }
        return $.post(opts.listUrl, opts.listOptions, (function(_this) {
          return function(response) {
            var html;
            if (opts.message_writer != null) {
              msgWriter.message_writer('write', response);
              msgWriter.message_writer('hide');
            }
            if (opts.template != null) {
              html = $(opts.template).render(response.data);
            } else {
              html = response;
            }
            _this.element.find('tbody').append(html);
            return opts.listCallback(_this.element, response);
          };
        })(this));
      },
      _createMessageWriter: function() {
        return this.element.after("<div class='message_writer' id='" + this.options.message_writer + "'");
      },
      _removeMessageWriter: function() {
        return $(this.options.message_writer).remove();
      }
    });
  });

}).call(this);
